export default {"src":"/_next/static/media/cplogo-primary.a8bfbbd3.svg","height":78,"width":378,"blurWidth":0,"blurHeight":0};